import { createStore } from 'owa-satcheljs';
import type { EnterpriseOrPremiumLicenseStore } from './schema/enterpriseOrPremiumLicenseStore';

const defaultEnterpriseOrPremiumLicenseStore: EnterpriseOrPremiumLicenseStore = {
    hasInitialized: false,
    enterpriseOrPremiumLicenseStatus: 'Unknown',
};

export const getStore: () => EnterpriseOrPremiumLicenseStore =
    createStore<EnterpriseOrPremiumLicenseStore>(
        'EnterpriseOrPremiumLicenseStore',
        defaultEnterpriseOrPremiumLicenseStore
    );
